<template>
  <v-card elevation="0">
    <v-card-title>Настройки логирования</v-card-title>
    <v-card-text>
      <v-row class="d-flex" dense>
        <v-col class="col-6">
          <v-text-field
            v-model="logConfig.level"
            :rules="[rules.logLevel]"
            label="Уровень логирования (1-10)"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="logConfig.retention_days"
            :rules="[rules.days]"
            label="Срок хранения .log файлов (дней)"
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-switch
            v-model="logConfig.metrics"
            label="Сборка статистики работы ПО"
          ></v-switch>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["logConfig"],
  methods: {
  },
  computed: {
    rules() {
      return {
        logLevel: v => (/^\d+$/.test(v)) && (v >= 1 && v <= 10) || 'Введите число от 1 до 10',
        days: v => (/^\d+$/.test(v)) && (v >= 0) || 'Введите корректное количество дней'
      }
    }
  }
};
</script>

<style>
</style>